import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import {
  getUpcomingSbatGroups,
  useGetSbatGroupListQuery,
} from 'features/classCreation';
import RescheduleClassesAcademyModuleFilter from '../RescheduleClassesAcademyModuleFilter';
import RescheduleClassesClassTypeFilter from '../RescheduleClassesClassTypeFilter';
import RescheduleClassesDateRangeFilter from '../RescheduleClassesDateRangeFilter';
import RescheduleClassesFilterChips from '../RescheduleClassesFilterChips';
import RescheduleClassesFilterDrawerHeader from '../RescheduleClassesFilterDrawerHeader';
import RescheduleClassesInstructorsFilter from '../RescheduleClassesInstructorsFilter';
import RescheduleClassesLectureTypeFilter from '../RescheduleClassesLectureTypeFilter';

function RescheduleClassesFilterDrawerContent() {
  const { superBatchId } = useParams();
  const { data } = useGetSbatGroupListQuery(Number(superBatchId));

  const upcomingSbatGroups = useMemo(
    () => getUpcomingSbatGroups(data?.data || []),
    [data?.data]
  );

  return (
    <>
      <RescheduleClassesFilterDrawerHeader />
      <div className="m-t-m m-b-xs h3 bold dark">All Filters</div>
      <RescheduleClassesFilterChips />
      <RescheduleClassesAcademyModuleFilter sbatGroups={upcomingSbatGroups} />
      <RescheduleClassesClassTypeFilter />
      <RescheduleClassesLectureTypeFilter />
      <RescheduleClassesInstructorsFilter />
      <RescheduleClassesDateRangeFilter />
    </>
  );
}

export default RescheduleClassesFilterDrawerContent;
